// extracted by mini-css-extract-plugin
export default {"socials":"SocialAuth_socials__7tp1n","socialsButton":"SocialAuth_socialsButton__DDDI6"};